import { ParticleTextureBlock } from "babylonjs";




export const LobbyDefaultConfig = {
    DevelopmentMode : true,
    Server : "neondemo.inputinput.com",
    Port : 3444  
}


/*

export const LobbyDefaultConfig = {
    Server : "parlor.works",
    Port : 3333,
    Room : "NSMLobbyRoom2",
    MediaChannel : "StammTesting_NSMDEV4"
}


*/

